import React, { Component, lazy, Suspense } from "react";
import "./index.css";
import { Outlet, Route, Routes } from "react-router-dom";
import { ErrorComponent } from "./components/ErrorComponent";
import { PanelErrorBoundary } from "./components/PanelErrorBoundary";
import LandingPage from "./pages/LandingPage";
import NoMatchRoute from "./pages/NoMatchRoute";
import ContactPage from "./pages/ContactPage";
import Test from "./pages/Test";
import { StoreProvider } from "./store/store";
import { LoginPage } from "./pages/LoginPage";
import { RequireAuth, SessionExpiry } from "./layout/RequireAuth";

// The panel (Mantine, the charts, the query cache and every page of it) is a chunk of its own: a visitor of the
// landing, contact or login page never downloads it.
const DashboardRoutes = lazy(() => import("./pages/dashboard/DashboardRoutes"));

/** What stands in while the panel loads. It uses Tailwind, which is already here: Mantine comes with the panel. */
function PanelLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center" role="status" aria-label="Ładowanie panelu">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-700 border-t-slate-300" />
    </div>
  );
}

/** The frame of the landing, login and contact pages; the panel brings its own. */
function SiteLayout() {
  return (
    <div className="text-black relative min-h-screen min-w-screen">
      <div className="flex">
        <div className="w-screen h-screen">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

class App extends Component {
  render() {
    return (
      <StoreProvider>
        <ErrorComponent>
          <SessionExpiry />
          <Routes>
            {/* Cała sekcja dashboard jest osłonięta logowaniem; wylogowany nie pobiera nawet panelu. */}
            <Route
              path="/dashboard/*"
              element={
                <RequireAuth>
                  {/* After a deploy the old chunks are gone: say so in Polish, with a way to reload. */}
                  <PanelErrorBoundary>
                    <Suspense fallback={<PanelLoading />}>
                      <DashboardRoutes />
                    </Suspense>
                  </PanelErrorBoundary>
                </RequireAuth>
              }
            />

            <Route element={<SiteLayout />}>
              <Route path="/" element={<LandingPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/test" element={<Test />} />
              <Route key="NotMatchRoute" path="*" element={<NoMatchRoute />} />
            </Route>
          </Routes>
        </ErrorComponent>
      </StoreProvider>
    );
  }
}

export default App;
